var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-container"},[_c('PageTitle'),_c('Chart',{attrs:{"balances":_vm.balances,"account-buttons":_vm.buttons,"is-customer-blocked":_vm.isCustomerBlocked}}),_c('MarketToday')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }